import {post,post1} from './httpBase'
//上传图片
export function lifeUpload(params) {
    return post1('https://upload.ynsjj88.com/qiniu/public', params)
}
//国庆专题活动
export function nationalActivity(params) {
    return post('/activity/list', params)
}

//民途生活获取可见范围价格
export function getLifePrice(params) {
    return post('/user/lifestyle/getlifestyleprice', params)
}
//民途生活下单
export function lifeAdd(params) {
    return post('/user/lifestyle/add', params)
}
//民途生活下单支付
export function lifePay(params) {
    return post('/order/wxpay/unifiedorder/lifestyleorder', params)
}
//民途生活首页
export function lifeHome(params) {
    return post('/user/lifestyle/lifestyleuser', params)
}
//民途生活详情
export function lifeInfo(params) {
    return post('/user/lifestyle/getlifestyledetails', params)
}
//民途我的
export function myList(params) {
    return post('/user/lifestyle/lifestyleuserlist', params)
}



// WEBPACK FOOTER //
// ./src/service/addLines.js